import { config } from "@/app/config";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState } from "app/store";
import axios from "axios";

import { setStaticUrls } from "./staticUrlsSlice";

export const getStaticUrls = createAsyncThunk<
  unknown,
  void,
  { state: RootState }
>(
  "staticUrls/getStaticUrls",
  async (_, { dispatch }) => {
    const response = await axios.get(
      `${config.cloudflareBaseUrl}/static/urls`
    );
    dispatch(setStaticUrls(response.data));
  }
);
